import { forwardRef, type Ref, type SVGProps } from "react";

function SvgHoursLimitSmall(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} viewBox="0 0 101 68" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_3299_53061)">
        <circle
          cx="50.4999"
          cy="33.9091"
          r="28.4091"
          stroke="url(#paint0_linear_3299_53061)"
          strokeWidth="10"
        />
      </g>
      <path
        d="M50.5 18L50.5 33.9091L59.0227 24.8182"
        stroke="#0C1C43"
        strokeWidth="0.568182"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="17.2614" y="5.96573" width="22.1591" height="22.1591" rx="11.0795" fill="#BD6801" />
      <rect
        x="17.2614"
        y="5.96573"
        width="22.1591"
        height="22.1591"
        rx="11.0795"
        stroke="white"
        strokeWidth="0.568182"
      />
      <path
        d="M28.3408 13.6367V17.614M28.3408 19.3185V19.8867"
        stroke="white"
        strokeWidth="0.852273"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3299_53061"
          x1="50.4999"
          y1="5.5"
          x2="50.4999"
          y2="62.3182"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.195043" stopColor="#FFE3C3" />
          <stop offset="1" stopColor="#F6F3F1" />
        </linearGradient>
        <clipPath id="clip0_3299_53061">
          <rect x="21.8069" y="5.5" width="56.8182" height="56.8182" rx="28.4091" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgHoursLimitSmall);
export default ForwardRef;
